import { transport } from 'config/transport';
import { toastHelper } from 'helpers/toastHelper';
import { call, put } from 'redux-saga/effects';
import FMI_ACTIONS from 'redux/actions';

export default function* getListOfCongDoanDanhMucChiCongDoanVung() {
    yield put({ type: FMI_ACTIONS.LOADING_STATUS__LOADING });
    try {
        let { data } = yield call(callApiGetListOfCongDoanDanhMucChiCongDoanVung);
        yield put({
            type: FMI_ACTIONS.VUNG__GET_LIST_DANH_MUC_CHI_SUCCESS,
            payload: { data },
        });
    } catch (e) {
        yield put({
            type: FMI_ACTIONS.VUNG__CALL_FAIL,
        });
        toastHelper.error(e.message);
    }
    yield put({ type: FMI_ACTIONS.LOADING_STATUS__LOADED });
}

export function callApiGetListOfCongDoanDanhMucChiCongDoanVung() {
    return transport.get(`/congdoanvung/thuchi/chicongdoanvung/danhmuc`);
}
